import { render, staticRenderFns } from "./customerBaseTemplateManage.vue?vue&type=template&id=f1069fe8&scoped=true&"
import script from "./customerBaseTemplateManage.vue?vue&type=script&lang=js&"
export * from "./customerBaseTemplateManage.vue?vue&type=script&lang=js&"
import style0 from "./customerBaseTemplateManage.vue?vue&type=style&index=0&id=f1069fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1069fe8",
  null
  
)

component.options.__file = "customerBaseTemplateManage.vue"
export default component.exports